<template>
  <footer>
    <div class="footer-t">
      <div class="f-logo">
        <div style="flex: 1">
          <img
            src="/static/images/f-logo.png"
            style="width: 90px; height: auto"
            alt=""
          />
        </div>

        <!-- <el-popover placement="top-end" width="300" trigger="hover">
          <div slot>
            <img :src="wxCode" style="width: 300px; height: 300px" />
          </div>
          <div slot="reference">
            <div>
              <el-image
                style="width: 63px; height: 63px; background: #fff"
                :src="wxCode"
                :preview-src-list="[wxCode]"
              >
              </el-image>
              <div style="width: 63px; text-align: center; color: #fff">
                小程序
              </div>
            </div>
          </div>
        </el-popover> -->
      </div>
      <div class="f-ba">
        <div
          style="
            height: 20px;
            line-height: 20px;
            color: #939393;
            margin-bottom: 5px;
          "
        >
          Copyright@大韩民国签证申请中心
        </div>
        <a
          target="_blank"
          href="https://beian.miit.gov.cn"
          style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
          "
        >
          <!-- <img src="/static/images/icon/gonganBa.png" style="float: left" /> -->
          <p
            style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
              color: #939393;
            "
          >
            {{ serverApi }}
          </p>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {},
  mounted() {},
  data() {
    return {
      content: `<el-image :src="'/static/images/zhuancun/gh_510d2ef1e614_430.jpg'"></el-image>`,
      address: "",
      email: "",
      icpBeiAn: "",
      phone: "",
    };
  },
  computed: {
    wxCode() {
      console.log();
      const setCenterId = this.$store.state.centerId;
      if (setCenterId === "B00005") {
        return "/static/images/wxCode/QINGDAO.jpg";
      } else if (setCenterId === "B00010") {
        return "/static/images/wxCode/WUHAN.png";
      } else if (setCenterId === "B00006") {
        return "/static/images/wxCode/GUANGZHOU.png";
      } else if (setCenterId === "B00009") {
        return "/static/images/wxCode/SHANGHAI.png";
      } else if (setCenterId === "B00011") {
        return "/static/images/wxCode/CHENGDU.png";
      } else if (setCenterId === "B00012") {
        // 北京
        return "/static/images/wxCode/CHENGDU.png";
      }
      return "/static/images/wxCode/QINGDAO.jpg";
    },
    serverApi() {
      return process.env.BEI_AN_NAME || '';
    }
  },
  methods: {
    navTo(name, type = 1) {
      if (type == 1 && name) {
        this.$router.push({ name });
      }
    },
    getAddress() {
      this.$api.global.getSysConfig("FOOTER_DI_ZHI_ne3o").then((res) => {
        this.address = res.result.data;
      });
    },
    getEmail() {
      this.$api.global.getSysConfig("FOOTER_YOU_XIANG_o58c").then((res) => {
        this.email = res.result.data;
      });
    },
    getIcpBeiAn() {
      this.$api.global.getSysConfig("FOOTERICP_BEI_AN_3t0v").then((res) => {
        this.icpBeiAn = res.result.data;
      });
    },
    getPhone() {
      this.$api.global.getSysConfig("400_HOTLINE").then((res) => {
        this.phone = res.result.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
footer {
  background: #26303d;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.footer-t {
  width: 1024px;
  .f-logo {
    width: 100%;
    margin: 20px 0 0 0;
    display: flex;
  }
  .f-ba {
    text-align: center;
    padding: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue